import { __assign, __rest } from "tslib";
import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import styles from './button.module.css';
import { NavLink } from 'react-router-dom';
import { SpinnerIcon } from '../../../design/assets/spinner/spinner.icon';
import { safeCallback } from '../../../library';
function ButtonInner(_a) {
    var _b;
    var _c = _a.isLoading, isLoading = _c === void 0 ? false : _c, _d = _a.loaderText, loaderText = _d === void 0 ? 'Saving...' : _d, disabled = _a.disabled, children = _a.children, clickType = _a.clickType, onTransitionPanelEnd = _a.onTransitionPanelEnd, isTouchDown = _a.isTouchDown, isTouchDownDone = _a.isTouchDownDone;
    var isButtonLoading = isLoading && !disabled;
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { className: styles.buttonInner }, isButtonLoading ? React.createElement(React.Fragment, null, loaderText) : React.createElement(React.Fragment, null, children)),
        isButtonLoading && (React.createElement("span", { className: styles.buttonSpinner },
            React.createElement(SpinnerIcon, { size: 24, tone: 'button-colour' }))),
        clickType === 'longpress' && React.createElement("div", { onTransitionEnd: onTransitionPanelEnd, className: classNames(styles.buttonLongPressPanel, (_b = {}, _b[styles.isTouchDown] = isTouchDown, _b[styles.isTouchDownDone] = isTouchDownDone, _b)) })));
}
export function Button(_a) {
    var _b;
    var _c = _a.arrow, arrow = _c === void 0 ? true : _c, _d = _a.noShadow, noShadow = _d === void 0 ? false : _d, _e = _a.tiny, tiny = _e === void 0 ? false : _e, _f = _a.isLoading, isLoading = _f === void 0 ? false : _f, _g = _a.theme, theme = _g === void 0 ? 'normal' : _g, type = _a.type, disabled = _a.disabled, href = _a.href, target = _a.target, filled = _a.filled, square = _a.square, fullWidthMobile = _a.fullWidthMobile, chubby = _a.chubby, grow = _a.grow, className = _a.className, clickType = _a.clickType, onClick = _a.onClick, props = __rest(_a, ["arrow", "noShadow", "tiny", "isLoading", "theme", "type", "disabled", "href", "target", "filled", "square", "fullWidthMobile", "chubby", "grow", "className", "clickType", "onClick"]);
    var isButtonLoading = isLoading && !disabled;
    var _h = useState(false), isTouchDown = _h[0], setIsTouchDown = _h[1];
    var _j = useState(false), isTouchDownDone = _j[0], setIsTouchDownDone = _j[1];
    useEffect(function () {
        function endPointer() {
            setIsTouchDown(false);
        }
        window.addEventListener('touchend', endPointer);
        window.addEventListener('mouseup', endPointer);
        return function () {
            window.removeEventListener('touchend', endPointer);
            window.removeEventListener('mouseup', endPointer);
        };
    });
    if ((type === 'a' || type === 'navlink') && !href)
        throw Error("\"type\" of \"a\" requires \"href\"");
    if (!!target && type !== 'a')
        throw Error("\"target\" can only be used with \"type\" of \"a\"");
    var classNamesOutput = classNames(styles.buttonWrapper, (_b = {},
        _b[styles.buttonFilled] = !!filled,
        _b[styles.hideArrow] = !arrow || !!square,
        _b[styles.noShadow] = noShadow,
        _b[styles.disabledButton] = disabled,
        _b[styles.tiny] = tiny,
        _b[styles.square] = square,
        _b[styles.buttonLoading] = isButtonLoading,
        _b[styles.fullWidthMobile] = fullWidthMobile,
        _b[styles.chubby] = chubby,
        _b[styles.grow] = grow,
        _b), styles[theme], className, "kplr_buttonWrapper");
    var eventConfig = {};
    if (clickType === 'longpress') {
        eventConfig = {
            onTouchStart: function () {
                setIsTouchDown(true);
            },
            onMouseDown: function () {
                setIsTouchDown(true);
            },
        };
    }
    else {
        eventConfig = {
            onClick: function () {
                if (!disabled)
                    safeCallback(onClick);
            },
        };
    }
    eventConfig.onContextMenu = function (event) { return event.preventDefault(); };
    function onEndTransition() {
        if (isTouchDown) {
            setIsTouchDownDone(true);
            if (!disabled)
                safeCallback(onClick);
            setTimeout(function () {
                setIsTouchDown(false);
                setTimeout(function () { return setIsTouchDownDone(false); }, 250);
            });
        }
    }
    if (type === 'a') {
        return (React.createElement("a", __assign({ className: classNames(classNamesOutput, "kplr_buttonAnchorWrapper"), href: href !== null && href !== void 0 ? href : '' }, eventConfig),
            React.createElement(ButtonInner, __assign({}, props, { type: type, isTouchDown: isTouchDown, isTouchDownDone: isTouchDownDone, onTransitionPanelEnd: function () { return onEndTransition(); } }))));
    }
    if (type === 'navlink') {
        return (React.createElement(NavLink, __assign({ className: classNames(classNamesOutput, "kplr_buttonNavLinkWrapper"), to: href !== null && href !== void 0 ? href : '' }, eventConfig),
            React.createElement(ButtonInner, __assign({}, props, { type: type, isTouchDown: isTouchDown, isTouchDownDone: isTouchDownDone, onTransitionPanelEnd: function () { return onEndTransition(); } }))));
    }
    return (React.createElement("button", __assign({ className: classNames(classNamesOutput, "kplr_buttonButtonWrapper") }, eventConfig),
        React.createElement(ButtonInner, __assign({}, props, { type: type, isTouchDown: isTouchDown, isTouchDownDone: isTouchDownDone, onTransitionPanelEnd: function () { return onEndTransition(); } }))));
}
export default Button;
